import { Component, OnInit, OnDestroy } from '@angular/core';
import { Tender, User, UserType } from 'toolbandi-ui-lib';
import { CrudService, MessageService, SharedDataService, Breadcrumb } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TenderEditComponent } from '../tender-edit/tender-edit.component';

@Component({
	selector: 'app-tender-view',
	templateUrl: './tender-view.component.html',
	styleUrls: ['./tender-view.component.scss']
})
export class TenderViewComponent implements OnInit, OnDestroy {

	datekeys: { field: string, showtime: boolean }[];
	currencykeys: string[];
	stringkeys: string[];
	longstringkeys: string[];
	booleankeys: string[];
	perckeys: string[];

	loading: boolean = false;
	tender: Tender;

	error: boolean;
	breadcrumb: Breadcrumb;
	isAdmin: boolean;

	constructor(
		private tenderService: CrudService<Tender>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private sharedDataService: SharedDataService,
		private route: ActivatedRoute,
		private modalService: NgbModal
	) {
		this.datekeys = [{
			field: 'startdate',
			showtime: false
		}, {
			field: 'stopdate',
			showtime: false
		},
		{
			field: 'projectdeadline',
			showtime: false
		},
		{
			field: 'insdate',
			showtime: true
		},
		{
			field: 'moddate',
			showtime: true
		}];
		this.stringkeys = ['id', 'name', 'minlength', 'maxlength'];
		this.longstringkeys = ['description', 'shortdesc'];
		this.booleankeys = ['microent', 'smallent', 'mediument', 'largeent'];
		this.currencykeys = ['minproject', 'maxproject'];
		this.perckeys = ['mincontribution', 'maxcontribution'];

		this.sharedDataService.currentLoggedUser.subscribe((data) => {
			if (data) {
				this.isAdmin = ((data as User).utype === UserType.admin);
			}
		});
	}

	ngOnInit(): void {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			this.load(id);
		});

	}

	ngOnDestroy(): void {
		this.sharedDataService.addCommonData('route', undefined);
	}

	load(id: number) {
		this.loading = true;
		this.tenderService.getEntity(Tender, 'tender', id).subscribe(tender => {
			this.tender = tender;
			this.loading = false;
			if (this.tender) {
				this.error = false;
				this.booleankeys = this.booleankeys.filter(bk => tender[bk]);
				this.setBreadcrumb();
			} else {
				this.error = true;
			}
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.tender'));
			this.tender = undefined;
			this.loading = false;
			this.error = true;
		});
	}

	setBreadcrumb() {

		this.breadcrumb = new Breadcrumb();
		this.breadcrumb.breadcrumbitems = [
			{ title: 'labels.tenders', url: '/tender' },
		];
		this.breadcrumb.title = { title: 'labels.view-tender', param: this.tender.name };
	}


	edit() {
		const modal = this.modalService.open(TenderEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});

		modal.componentInstance.load(this.tender.id);

		modal.result.then((newItem: Tender) => {
			this.load(this.tender.id);
		}).catch(() => { });
	}

	attachmentsChanged(): void {

	}

}
